import { computed, ref } from "@vue/composition-api";
import { ActiveRecording, recordAudio } from "@/lib/mediaRecord";
import { isGetUserMediaSupported } from "@/lib/webrtcHelpers";
import config from "@/config";

const AUDIO_MAX_DURATION = 60000;
const AUDIO_MIN_DURATION = 1000;

export default function useAudioRecording() {
  const audioFile = ref<File>();
  const activeRecording = ref<Promise<ActiveRecording> | null>(null);
  const durationMs = ref(0);
  let timerId: ReturnType<typeof setInterval>;
  const recording = ref(false);

  const isAudioRecordingAvailable = computed(() => config.featureAudioMessageAttachments && isGetUserMediaSupported());

  const stopRecord = async () => {
    if (activeRecording.value) {
      const file = await (await activeRecording.value).stop();
      recording.value = false;
      if (durationMs.value > AUDIO_MIN_DURATION) {
        audioFile.value = file;
      }
      activeRecording.value = null;
      clearInterval(timerId);
      durationMs.value = 0;
    }
  };
  const startRecord = async () => {
    activeRecording.value = recordAudio();
    await activeRecording.value;
    recording.value = true;
    if (timerId) {
      clearInterval(timerId);
    }
    timerId = setInterval(() => {
      durationMs.value += 1000;
      if (durationMs.value > AUDIO_MAX_DURATION) {
        stopRecord();
      }
    }, 1000);
  };

  return { isAudioRecordingAvailable, recording, durationMs, audioFile, startRecord, stopRecord };
}
